import QueryReTable from "../components/QueryReTable";
import { useUserServices } from "../context/DealerProfile";
import OrderLists from "../features/order/OrderLists";
import useQueryTable from "../hooks/useQueryTable";

const OrderHistoryPage = () => {
  const {
    dealerDetail: { accountName, isChannelPartner, dealerName },
  } = useUserServices();
  const [isLoading, data, searchValues, setSearchValues, moreData, totalData] =
    useQueryTable({
      queryList: ["page", "Stage"],
      // url: "/server/dealer_backend/order-history/" + crmUserDetail?.dealer?.id,
      url: `/server/dealer_backend/${
        isChannelPartner ? "order-history" : "order-history-customer"
      }/${isChannelPartner ? accountName?.id : dealerName?.id}`,
    });

  const {
    data: { data: orders },
  } = data ?? { data: { data: [] } };

  return (
    <QueryReTable
      heading={"Order History"}
      headingNeed={true}
      moreData={moreData}
      totalData={totalData}
      searchValues={searchValues}
      setSearchValues={setSearchValues}
    >
      <OrderLists isLoading={isLoading} setSearchValues={setSearchValues} orders={orders} key={"something"} />
    </QueryReTable>
  );
};

export default OrderHistoryPage;
